import { c as _c } from "react/compiler-runtime";
import { Badge } from '@achra/ui/badge';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@achra/ui/empty';
import { cn } from '@achra/ui/lib/utils';
import { Spinner } from '@achra/ui/spinner';
import { CheckIcon, WifiOffIcon } from 'lucide-react';
import { useNetworkState } from 'react-use';
interface NetworkErrorStateProps {
  showBorder?: boolean;
  className?: string;
}
function NetworkErrorState(t0) {
  const $ = _c(13);
  const {
    showBorder: t1,
    className
  } = t0;
  const showBorder = t1 === undefined ? true : t1;
  const {
    online
  } = useNetworkState();
  const t2 = showBorder && "border border-solid";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("bg-background mx-auto w-full max-w-sm md:p-6", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EmptyHeader><EmptyMedia variant="icon"><WifiOffIcon /></EmptyMedia><EmptyTitle>You are offline</EmptyTitle><EmptyDescription>Please check your internet connection and try again.</EmptyDescription></EmptyHeader>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = online ? "success" : "outline";
  let t6;
  if ($[4] !== online) {
    t6 = online ? <CheckIcon className="color-status-success" /> : <Spinner />;
    $[4] = online;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = online ? "Your connection is back!" : "Checking your connection...";
  let t8;
  if ($[6] !== t5 || $[7] !== t6 || $[8] !== t7) {
    t8 = <EmptyContent><Badge variant={t5}>{t6}{t7}</Badge></EmptyContent>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t3 || $[11] !== t8) {
    t9 = <Empty className={t3}>{t4}{t8}</Empty>;
    $[10] = t3;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}
export { NetworkErrorState };